import { Vector3 } from './vector3';

export interface Quaternion {
  x: number;
  y: number;
  z: number;
  w: number;
}

/**
 * Create new quaternion based on euler angles
 * @param euler Euler angles in degrees
 */
export function fromEuler(euler: Vector3): Quaternion {
  const yaw = euler.y * deg2Rad;
  const pitch = euler.x * deg2Rad;
  const roll = euler.z * deg2Rad;
  const rollOver2 = roll * 0.5;
  const sinRollOver2 = Math.sin(rollOver2);
  const cosRollOver2 = Math.cos(rollOver2);
  const pitchOver2 = pitch * 0.5;
  const sinPitchOver2 = Math.sin(pitchOver2);
  const cosPitchOver2 = Math.cos(pitchOver2);
  const yawOver2 = yaw * 0.5;
  const sinYawOver2 = Math.sin(yawOver2);
  const cosYawOver2 = Math.cos(yawOver2);
  const w = cosYawOver2 * cosPitchOver2 * cosRollOver2 + sinYawOver2 * sinPitchOver2 * sinRollOver2;
  const x = cosYawOver2 * sinPitchOver2 * cosRollOver2 + sinYawOver2 * cosPitchOver2 * sinRollOver2;
  const y = sinYawOver2 * cosPitchOver2 * cosRollOver2 - cosYawOver2 * sinPitchOver2 * sinRollOver2;
  const z = cosYawOver2 * cosPitchOver2 * sinRollOver2 - sinYawOver2 * sinPitchOver2 * cosRollOver2;
  return { x, y, z, w };
}

/**
 * Create identity quaternion
 */
export function identity(): Quaternion {
  return { x: 0, y: 0, z: 0, w: 0 };
}

const deg2Rad = 0.01745329;
